import React from 'react';
import { Card } from 'reactstrap';

const SEVERITY_ROWS = [
  {
    level: 'Critical',
    description:
      'Control failure represents a high-impact security risk and should be reviewed immediately.',
  },
  {
    level: 'High',
    description:
      'Control failure may expose important cloud resources or permissions and should be prioritized.',
  },
  {
    level: 'Medium',
    description:
      'Control failure indicates a moderate security concern that should be reviewed and remediated.',
  },
  {
    level: 'Low',
    description:
      'Control failure indicates a lower-risk hardening or configuration improvement.',
  },
];

const BPASeverityDescriptions: React.FC = () => {
  return (
    <Card className="p-1 overflow-auto">
      <h5>Severity Level of BPA Finding</h5>
      <table
        className="table table-bordered table-striped table-hover"
        style={{
          maxWidth: '600px',
          tableLayout: 'fixed',
        }}
      >
        <thead className="thead-light">
          <tr>
            <th className="p-1" style={{ width: '80px', textAlign: 'left' }}>
              Level
            </th>
            <th className="p-1" style={{ width: '100%', textAlign: 'left' }}>
              Description
            </th>
          </tr>
        </thead>
        <tbody>
          {SEVERITY_ROWS.map((row) => (
            <tr key={row.level}>
              <td className="p-1 text-wrap" style={{ wordBreak: 'break-word' }}>
                {row.level}
              </td>
              <td className="p-1 text-wrap" style={{ wordBreak: 'break-word' }}>
                {row.description}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Card>
  );
};

export default BPASeverityDescriptions;
